module.exports = __webpack_public_path__ + "img/D202306_2.603d3627.jpg";